import { createRouter, createWebHistory } from 'vue-router'
import BodyView from '../layout/BodyView.vue'
import auth from "../auth/authView.vue"
import login from "../auth/loginPage.vue"

import IndexDefault from '../components/dashboard/default/IndexDefault.vue'
import indexEcommerce from '../components/dashboard/e-commerce/indexEcommerce'


import indexGeneral from '../components/widgets/general/indexGeneral'
import indexChart from '../components/widgets/charts/indexChart'


import indexList from '../components/project/projectlist/indexList'
import createProject from '../components/project/createproject/createProject'

import kanbanBoard from "../components/kanban/kanbanBoard"
import file_manager from "../components/filemaneger/file_manager"


import indexProduct from "../components/ecommerce/product/indexProduct"
import cartView from "../components/ecommerce/cartView"
import indexAdd from "../components/ecommerce/addproduct/indexAdd"
import productDetails from "../components/ecommerce/productDetails/productDetails"
import checkOut from "../components/ecommerce/chekout/checkOut"
import wishList from "../components/ecommerce/wishList"
import invoiceView from "../components/ecommerce/invoice/invoiceView"
import PaymentDetails from "../components/ecommerce/paymentDetails/PaymentDetails"
import orderHistory from "../components/ecommerce/orderhistory/orderHistory"


import indexEmail from "../components/email/indexEmail"


import indexChat from "../components/chat/chatList/indexChat"
import videoChat from "../components/chat/videoChat/videoChat"


import userProfile from "../components/users/profile/userProfile"
import editProfile from "../components/users/editProfile/editProfile"
import cardIndex from "../components/users/userCards/cardIndex"

import bookMark from "../components/bookmark/bookMark.vue"


import socialApp from "../components/socialApp/socialApp"


import todoIndex from "../components/todo/todoIndex"


import serchIndex from "../components/search/serchIndex"


import formValidation from "../components/forms/formValidetion/formValidation"
import base_Input from "../components/forms/baseInput/base_Input"
import checkbox_radio from "../components/forms/Checkbox&Radio/checkbox_radio"
import input_groups from "../components/forms/InputGroup/input_groups"
import megaOptions from "../components/forms/megaOptions/megaOptions"


import select2 from "../components/formWidgets/select2/select2"
import switch_From from "../components/formWidgets/switch/switch_From"
import touchspin_Form from "../components/formWidgets/touchspin/touchspin_Form"
import typeahead_Form from "../components/formWidgets/typeahead/typeahead_Form"
import clipboard_Form from "../components/formWidgets/clipboard/clipboard_Form"
import datepicker from "../components/formWidgets/datepicker/datepicker"


import form_wizard from "../components/formwizard/form_wizard"


import basic_tables from "../components/tables/bootstrapTable/basicTables/basic_tables"
import sizing_tables from "../components/tables/bootstrapTable/sizeTable/sizing_tables"
import border_Tables from "../components/tables/bootstrapTable/borderTables/border_Tables"
import styling_table from "../components/tables/bootstrapTable/stylingtable/styling_table"


import basic_Init from "../components/tables/dataTable/BasicInit/basic_Init"


import state_Color from "../components/uikits/statecolor/state_Color"
import typograPhy from "../components/uikits/Typography/typograPhy"
import avatars_Uikits from "../components/uikits/Avatars/avatars_Uikits"
import helper_classes from "../components/uikits/helper/helper_classes"
import grid_Uikits from "../components/uikits/grid/grid_Uikits"
import tag_pills from "../components/uikits/Tag&Pills/tag_pills"
import progress_bar from "../components/uikits/progressBar/progress_bar"
import modal_Uikit from "../components/uikits/modal/modal_Uikit"
import alert_Uikit from "../components/uikits/alert/alert_Uikit"
import popover_Uikit from "../components/uikits/Popover/popover_Uikit"
import tooltip_uikits from "../components/uikits/tooltip/tooltip_uikits"
import spinners_Uikit from "../components/uikits/Spinners/spinners_Uikit"
import accordion_Uikit from "../components/uikits/accordion/accordion_Uikit"
import box_shadow from "../components/uikits/Shadow/box_shadow"
import list_Uikit from "../components/uikits/list/list_Uikit"
import dropdown_Uikit from "../components/uikits/Dropdown/dropdown_Uikit"


import scrollable_advance from "../components/advance/Scrollable/scrollable_advance"
import pagination_advance from "../components/advance/Pagination/pagination_advance"
import sweetAlert from "../components/advance/SweetAlert/sweetAlert"
import ribbons_advance from "../components/advance/Ribbons/ribbons_advance"
import breadCrumb from "../components/advance/Breadcrumb/breadCrumb"
import cropper_advance from "../components/advance/cropper/cropper_advance"
import toaster_advance from "../components/advance/Toaster/toaster_advance"
import tour_advance from "../components/advance/Tour/tour_advance"
import rating_advance from "../components/advance/Rating/rating_advance"
import upload_advance from "../components/advance/upload/upload_advance"
import sticky_advance from "../components/advance/sticky/sticky_advance"
import range_advance from "../components/advance/rangeSlider/range_advance"
import dragdrop from "../components/advance/dragdrop/dragdrop"


import flag_Icon from "../components/icon/flag_Icon"
import feather_icon from "../components/icon/feather_icon"
import weather_icon from "../components/icon/weather_icon"
import themify_icon from "../components/icon/themify_icon"
import font_Awesome from "../components/icon/fontAwesome/font_Awesome"
import icon_Icon from "../components/icon/icon_Icon"


import default_button from "../components/button/Default/default_button"
import flat_button from "../components/button/Flat/flat_button"
import edge_button from "../components/button/Edge/edge_button"
import raised_button from "../components/button/Raised/raised_button"
import button_group from "../components/button/ButtonGroup/button_group"


import google_chart from "../components/charts/googleChart/google_chart"
import apex_chart from "../components/charts/ApexChart/apex_chart"
import chartist_chart from "../components/charts/Chartist/chartist_chart"


import grid_gallery from "../components/gallery/grid_gallery"
import grid_desc from "../components/gallery/grid_desc"
import hover_gallery from "../components/gallery/hover-gallery/hover_gallery"
import masonry_gallery from "../components/gallery/masonry-gallery/masonry_gallery"
import masonary_desc from "../components/gallery/masonary_desc"

import errorPage1 from '../errors/errorPage1.vue';
import errorPage2 from '../errors/errorPage2.vue';
import errorPage3 from '../errors/errorPage3.vue';
import errorPage4 from '../errors/errorPage4.vue';




import BasicView from '../components/cards/basicView/basicView.vue';
import DraggableView from '../components/cards/draggableView';
import creative_card from "../components/cards/creative/creative_card"
import tabbed_card from "../components/cards/Tabbed/tabbed_card"


import login_image from "../components/authentication/login_image"
import login_image2 from "../components/authentication/login_image2"
import ragister_simple from "../components/authentication/ragister_simple"
import ragister_image from "../components/authentication/ragister_image"
import ragister_image2 from "../components/authentication/ragister_image2"
import login_with_validation from "../components/authentication/login_with_validation"
import unlock from "../components/authentication/unlock"
import forget_password from "../components/authentication/forget_password"
import reset_password from "../components/authentication/reset_password"
import login_simple from "../components/authentication/login_simple.vue"


import timeline from "../components/timeline/timeline"


import google_map from "../components/maps/google_map"
import vue_leaflet from "../components/maps/vue_leaflet"

import ckediter from "../components/editer/ckediter"
import simple_editer from "../components/editer/simple_editer"


import blog_detail from "../components/blog/blog-details/blog_detail"
import blog_single from "../components/blog/blog-single/blog_single"


import job_list from "../components/job/job-list/job_list"
import job_details from "../components/job/job_details/job_details"
import job_apply from "../components/job/job_apply/job_apply"


import learning_list from "../components/learning/learninglist/learning_list"
import coursedetailed from "../components/learning/coursedetailed"

// Owner Components
import OwnerDashboard from "../components/owner/dashboard/OwnerDashboard.vue"
import BranchList from "../components/owner/branches/BranchList.vue"
import BranchForm from "../components/owner/branches/BranchForm.vue"
import TableList from "../components/owner/tables/TableList.vue"
import StaffList from "../components/owner/staff/StaffList.vue"
import StaffForm from "../components/owner/staff/StaffForm.vue"
// Inventory Management
import CategoryList from "../components/owner/categories/CategoryList.vue"
import CategoryForm from "../components/owner/categories/CategoryForm.vue"
import ProductList from "../components/owner/products/ProductList.vue"
import ProductForm from "../components/owner/products/ProductForm.vue"
import AddonList from "../components/owner/addons/AddonList.vue"
import AddonForm from "../components/owner/addons/AddonForm.vue"
import StockList from "../components/owner/stock/StockList.vue"
import StockMovementHistory from "../components/owner/stock/StockMovementHistory.vue"
import TransferList from "../components/owner/transfers/TransferList.vue"
import TransferForm from "../components/owner/transfers/TransferForm.vue"
import TransferDetail from "../components/owner/transfers/TransferDetail.vue"
// Customer Management
import CustomerList from "../components/owner/customers/CustomerList.vue"
import CustomerDetail from "../components/owner/customers/CustomerDetail.vue"
// Subscription Management
import SubscriptionPlans from "../components/owner/subscription/SubscriptionPlans.vue"
import BillingHistory from "../components/owner/subscription/BillingHistory.vue"
// Online Orders
import OrderList from "../components/owner/orders/OrderList.vue"
import OrderDetail from "../components/owner/orders/OrderDetail.vue"
// Loyverse POS Integration
import OwnerNotifications from "../components/owner/notifications/Notifications.vue"
import OwnerReviews from "../components/owner/reviews/ReviewList.vue"
import OwnerLoyaltyGuide from "../components/owner/loyalty/LoyaltyGuide.vue"
import OwnerReports from "../components/owner/reports/Reports.vue"
import OwnerSettings from "../components/owner/settings/Settings.vue"

import LoyverseOrders from "../components/owner/loyverse/LoyverseOrders.vue"
import LoyverseSettings from "../components/owner/loyverse/LoyverseSettings.vue"

// Super Admin Components
import PlatformDashboard from "../components/superAdmin/dashboard/PlatformDashboard.vue"
import SACompanyList from "../components/superAdmin/companies/CompanyList.vue"
import SACompanyDetail from "../components/superAdmin/companies/CompanyDetail.vue"
import SACustomerList from "../components/superAdmin/customers/CustomerList.vue"
import SACustomerDetail from "../components/superAdmin/customers/CustomerDetail.vue"
import SASubscriptionList from "../components/superAdmin/subscriptions/SubscriptionList.vue"
import SAPlanManager from "../components/superAdmin/subscriptions/PlanManager.vue"
import SAInvoiceList from "../components/superAdmin/subscriptions/InvoiceList.vue"
import SAWalletDashboard from "../components/superAdmin/wallets/WalletDashboard.vue"
import SAPromoList from "../components/superAdmin/promos/PromoList.vue"
import SAPromoForm from "../components/superAdmin/promos/PromoForm.vue"
import SATierList from "../components/superAdmin/loyalty/TierList.vue"
import SATierForm from "../components/superAdmin/loyalty/TierForm.vue"
import SALoyaltySettings from "../components/superAdmin/loyalty/LoyaltySettings.vue"
// Super Admin Delivery
import SADeliveryDashboard from "../components/superAdmin/delivery/DeliveryDashboard.vue"
import SADeliveryList from "../components/superAdmin/delivery/DeliveryList.vue"
import SADeliverySettings from "../components/superAdmin/delivery/DeliverySettings.vue"
import SARiderList from "../components/superAdmin/delivery/RiderList.vue"

import faqindex from "../components/faq/faqindex"



import knowledgebase from "../components/Knowledgebase/knowledgebase"


import support from "../components/support/support"


import pricing from "../components/Pricing/pricing"


import maintenance from "../components/maintenance"

import sample_page from "../components/sample_page"


import calender from "../components/calendar/calender"

import ComingsoonImage from '../components/comingsoon/comingsoon_image';
import ComingsoonSimple from '../components/comingsoon/comingsoon_simple';
import ComingsoonVideo from '../components/comingsoon/comingsoon_video';
const routes = [
  {
    path: "",
    redirect: "/dashboard/default",
  },
  {
    path: '/',
    component: BodyView,
   
    children: [
    {
      path: '',
      name: 'defaultRoot',
      component: IndexDefault,
      meta: {
        title: 'GetLokal Admin',
      }
    },
    
    ]
  },
  {
    path: '/dashboard',
    component: BodyView,
   
    children: [
    {
      path: 'default',
      name: 'defaultIndex',
      component: IndexDefault,
      meta: {
        title: 'Dashboard',
      }
    },
    {
      path: 'indexEcommerce',
      name:'E-Commerce',
      component: indexEcommerce,
      meta: {
        title: 'Dashboard Ecommerce',
      }
    },
    
    ]
  },
  {
    path:'/widgets',
    component:BodyView,
    children:[
      {
        path:'indexGeneral',
        name:'general',
        component:indexGeneral,
        meta: {
          title: 'Widgets General',
        }
      },
      {
        path:'indexchart',
        name:'charts',
        component:indexChart ,
        meta: {
          title: 'Widgets Chart',
        }
      }
    ]
  },
  {
    path:'/project',
    component:BodyView,
    children:[
      {
        path:'indexList',
        name:'projectlist',
        component:indexList,
        meta: {
          title: 'Project List| GetLokal Admin',
        }
      },
      {
        path:'createProject',
        name:'createProject',
        component:createProject,
        meta: {
          title: 'Create Project| GetLokal Admin',
        }
      }
    ]
  },

  {
    path: '/error-page1',
    name: 'errorPage1',
    component: errorPage1,
    meta: {
      title: 'Error Page1| GetLokal Admin',
    }
  },
  {
    path: '/error-page2',
    name: 'errorPage2',
    component: errorPage2,
    meta: {
      title: 'Error Page2| GetLokal Admin',
    }
  },
  {
    path: '/error-page3',
    name: 'errorPage3',
    component: errorPage3,
    meta: {
      title: 'Error Page3| GetLokal Admin',
    }
  },
  {
    path: '/error-page4',
    name: 'errorPage4',
    component: errorPage4,
    meta: {
      title: 'Error Page4| GetLokal Admin',
    }
  },
  
  
  {
    path: '/cards',
    component: BodyView,
    children: [
      {
        path: 'basicView',
        name: 'BasicView',
        component: BasicView,
        meta: {
          title: 'BootstrapStyling Card',
        }
      },
      {
        path: 'draggableView',
        name: 'DraggableView',
        component: DraggableView,
        meta: {
          title: 'Draggable Card',
        }
      },
      {
        path:"creative",
        name:"creative",
        component:creative_card,
        meta: {
          title: 'Creative card',
        }
      },
      {
        path:"tabbed",
        name:"tabbed",
        component:tabbed_card,
        meta: {
          title: 'Tabbed Card',
        }
      }
    ]
  },
  {
    path:'/comingsoon/comingsoon-image',
    name:'ComingsoonImage',
    component:ComingsoonImage,
    meta: {
        title: 'ComingsoonImage',
      }
  },
  {
    path:'/comingsoon/comingsoon-simple',
    name:'ComingsoonSimple',
    component:ComingsoonSimple,
    meta: {
        title: 'ComingsoonSimple',
      }
  },
  {
    path:'/comingsoon/comingsoon-video',
    name:'ComingsoonVideo',
    component:ComingsoonVideo,
    meta: {
        title: 'ComingsoonVideo',
      }
  },
  {
    path:"/maintenance",
    name:"maintenance",
    component:maintenance,
    meta: {
      title: 'Maintenance',
    }
  },
  {
    path:"/knowledgebase",
    component:BodyView,
    children:[
      {
        path:"",
       name:"knowledgebase",
       component:knowledgebase,
       meta: {
        title: 'Knowledgebase| GetLokal Admin',
      }
      }
    ]
  },


    
  {
    path: '/app',
    component: BodyView,
    
    children: [
      {
        path: 'file_manager',
        name: 'defaultView3',
        component: file_manager,
        meta: {
          title: 'File Manager| GetLokal Admin',
        }
      },
    {
      path: 'kanbanBoard',
      name: 'defaultView2',
      component: kanbanBoard,
      meta: {
        title: 'kanban Board| GetLokal Admin',
      }
    },
    {
      path:"email",
      name:"email",
      component:indexEmail,
      meta: {
        title: 'Email',
      }
    },
    {
      path:"chat",
      name:"chat",
      component:indexChat,
      meta: {
        title: 'Chat App| GetLokal Admin',
      }
    },
    {
      path:"videochat",
      name:"videoChat",
      component:videoChat,
      meta: {
        title: 'Video Chat| GetLokal Admin',
      }
    },
    {
      path:"bookmark",
      name:"Bookmark",
      component:bookMark,
      meta: {
        title: 'Bookmark| GetLokal Admin',
      }
    },
    {
        path:"todo",
        name:"todo",
        component:todoIndex,
        meta: {
          title: 'To Do| GetLokal Admin',
        }
      },

      {
        path:"calendar",
        name:"calender",
        component:calender,
        meta: {
          title: 'Calendar| GetLokal Admin',
        }
      }
    ]
  },
  {
    path:"/pages",
    component:BodyView,
    children:[
      {
        path:"social-app",
        name:"socialapp",
        component:socialApp,
        meta: {
          title: 'Social App| GetLokal Admin',
        }
      },
      {
        path:"search",
        name:"search",
        component:serchIndex,
        meta: {
          title: 'Search| GetLokal Admin',
        }
      },
      {
        path:"sample-page",
        name:"samplepage",
        component:sample_page,
        meta: {
          title: 'Simple Page| GetLokal Admin',
        }
      },
      {
        path:"faq",
        name:"faqindex",
        component:faqindex,
        meta: {
          title: 'Faq| GetLokal Admin',
        }
      },
      {
        path:"support",
        name:"support",
        component:support,
        meta: {
          title: 'Support| GetLokal Admin',
        }
      },
      {
        path:"pricing",
        name:"pricing",
        component:pricing,
        meta: {
          title: 'Pricing| GetLokal Admin',
        }
      }
     
    ]
  },

  {
    path: '/ecommerce',
    component: BodyView,
    
    children: [
      {
        path: 'indexProduct',
        name: 'ecommerce',
        component: indexProduct,
        meta: {
          title: 'Product',
        }
      },
      {
        path: 'cartView',
        name: 'chart',
        component: cartView,
        meta: {
          title: 'Cart',
        }
      },
      {
        path:'details/:id',
        name:'prouctDetails',
        component:productDetails,
        meta: {
          title: 'Product Page',
        }
      },
      {
        path:"checkOut",
        name:"checkout",
        component:checkOut,
        meta: {
          title: 'Checkout',
        }
      },
      {
        path:"wishList",
        name:"wisthlist",
        component:wishList,
        meta: {
          title: 'Wish List',
        }
      },
      {
       path:"invoiceView",
       name:"invoice",
       component:invoiceView,
       meta: {
        title: 'Invoice',
      }
      },
      {
        path:"payment/details",
        name:"payment",
        component:PaymentDetails,
        meta: {
          title: 'Payment Detail',
        }
      },
      {
        path:"order/history",
        name:"orderHistory",
        component:orderHistory,
        meta: {
          title: 'Order History',
        }

      },
      {
        path:"add-product",
        name:"addproduct",
        component:indexAdd,
        meta: {
          title: 'Add Product',
        }
      }
    ]
  },
  {
    path:"/users",
    component:BodyView,
    children:[
      {
        path:"/users/profile",
        name:"userProfile",
        component:userProfile,
        meta: {
          title: 'User Profile| GetLokal Admin',
        }
      },
      {
        path:"/users/edit",
        name:"edit",
        component:editProfile,
        meta: {
          title: 'User Edit| GetLokal Admin',
        }
      },
      {
        path:"/users/cards",
        name:"userCard",
        component:cardIndex,
        meta: {
          title: 'User Cards| GetLokal Admin',
        }
      }
    ]

  },
  {
    path:"/form",
    component:BodyView,
    children:[
      {
        path:"validation",
        name:"formValidation",
        component:formValidation,
        meta: {
          title: 'Form Controls Form Validation| GetLokal Admin',
        }
      },
      {
        path:"inputs",
        name:"basicInput",
        component:base_Input,
        meta: {
          title: 'Form Controls Base Input| GetLokal Admin',
        }
      },
      {
        path:"checkbox-radio",
        name:"checkbox & radio",
        component:checkbox_radio,
        meta: {
          title: 'Form Controls Checkbox & Radio| GetLokal Admin',
        }
      },
      {
        path:"input-groups",
        name:"input Groups",
        component:input_groups,
        meta: {
          title: 'Form Controls Input Groups| GetLokal Admin',
        }
      },
      {
        path:"mega-options",
        name:"megaOptions",
        component:megaOptions,
        meta: {
          title: 'Form Controls Mega Options| GetLokal Admin',
        }
      },
      {
        path:"select2",
        name:"select2",
        component:select2,
        meta: {
          title: 'Form Widgets Select| GetLokal Admin',
        }
      },
      {
        path:"switch",
        name:"switch",
        component:switch_From,
        meta: {
          title: 'Form Widgets Switch| GetLokal Admin',
        }
      },
      {
        path:"touchspin",
        name:"touchspin",
        component:touchspin_Form,
        meta: {
          title: 'Form Widgets Touchspin| GetLokal Admin',
        }
      },
      {
        path:"typeahead",
        name:"typeahead",
        component:typeahead_Form,
        meta: {
          title: 'Form Widgets Typeahead| GetLokal Admin',
        }
      },
      {
        path:"clipboard",
        name:"clipboard",
        component:clipboard_Form,
        meta: {
          title: 'Form Widgets Clipboard| GetLokal Admin',
        }
      },
      {
        path:"wizard",
        name:"formwizard",
        component:form_wizard,
        meta: {
          title: 'Form Layout Form Wizard 1| GetLokal Admin',
        }
      },
      {
        path:"datepicker",
        name:"datepicker",
        component:datepicker,
        meta: {
          title: ' Datepicker| GetLokal Admin',
        }
      }
    ]
  },
  {
    path:"/table",
    component:BodyView,
    children:[
      {
        path:"basic",
        name:"basic1",
        component:basic_tables,
        meta: {
          title: 'Table Bootstrap Table| GetLokal Admin',
        }
      },
      {
        path:"sizing",
        name:"sizing",
        component:sizing_tables,
        meta: {
          title: 'Sizing Table| GetLokal Admin',
        }
      },
      {
        path:"border",
        name:"border",
        component:border_Tables,
        meta: {
          title: 'Border Table| GetLokal Admin',
        }
      },
      {
        path:"styling",
        name:"styling",
        component:styling_table,
        meta: {
          title: 'Style Table| GetLokal Admin',
        }
      },
      {
        path:"/datatable-basic",
        name:"datatable",
        component:basic_Init,
        meta: {
          title: 'Table Basic Init| GetLokal Admin',
        }
      },
   
    ]
  },
  {
    path:"/uikits",
    component:BodyView,
    children:[
      {
        path:"typography",
        name:"typography",
        component:typograPhy,
        meta: {
          title: 'Uikits Typography',
        }
      },
      {
        path:"avatars",
        name:"avatars",
        component:avatars_Uikits,
        meta: {
          title: 'Uikits Avatars',
        }
      },
      {
        path:"helper-classes",
        name:"helper",
        component:helper_classes,
        meta: {
          title: 'Uikits Helper Classes',
        }
      },
      {
        path:"grid",
        name:"grid",
        component:grid_Uikits,
        meta: {
          title: 'Uikits Grid',
        }
      },
      {
        path:"tag-pills",
        name:"tag&pills",
        component:tag_pills,
        meta: {
          title: 'Uikits Tag & Pills',
        }
      },
      {
        path:"progress-bar",
        name:"progressbar",
        component:progress_bar,
        meta: {
          title: 'Uikits Progressbar',
        }
      },
      {
        path:"modal",
        name:"modal",
        component:modal_Uikit,
        meta: {
          title: 'Uikits Modal',
        }
      },
      {
        path:"alert",
        name:"alert",
        component:alert_Uikit,
        meta: {
          title: 'Uikits Alert',
        }
      },
      {
        path:"popover",
        name:"popover",
        component:popover_Uikit,
        meta: {
          title: 'Uikits popover',
        }
      },
      {
        path:"tooltip",
        name:"tooltip",
        component:tooltip_uikits,
        meta: {
          title: 'Uikits Tooltip',
        }
      },
      {
        path:"loader",
        name:"spinners",
        component:spinners_Uikit,
        meta: {
          title: 'Uikits Spinners',
        }
      },
      {
        path:"accordion",
        name:"accordion",
        component:accordion_Uikit,
        meta: {
          title: 'Uikits Accordion',
        }
      },
      {
        path:"box-shadow",
        name:"boxshadow",
        component:box_shadow,
        meta: {
          title: 'Uikits Shadow',
        }
      },
      {
        path:"lists",
        name:"list",
        component:list_Uikit,
        meta: {
          title: 'Uikits Lists',
        }
      },
      {
        path:"dropdown",
        name:"dropdown",
        component:dropdown_Uikit,
        meta: {
          title: 'Uikits Dropdown',
        }
      }
    ]
  },
  {
    path:"/advance",
    component:BodyView,
    children:[
      {
        path:"scrollable",
        name:"scrollable",
        component:scrollable_advance,
        meta: {
          title: 'Bonus UI  Scrollable',
        }
      },
      {
        path:"pagination",
        name:"pagination",
        component:pagination_advance,
        meta: {
          title: 'Bonus UI  Pagenation',
        }
      },
      {
        path:"sweetalert",
        name:"sweetAlert",
        component:sweetAlert,
        meta: {
          title: 'Bonus UI  SweetAlert',
        }
      },
      {
        path:"ribbons",
        name:"ribbons",
        component:ribbons_advance,
        meta: {
          title: 'Bonus UI  Ribbons',
        }
      },
      {
        path:"breadcrumb",
        name:"breadCrumb",
        component:breadCrumb,
        meta: {
          title: 'Bonus UI  Breadcrumb',
        }
      },
      {
        path:"image-cropper",
        name:"cropper",
        component:cropper_advance,
        meta: {
          title: 'Bonus UI  ImageCropper',
        }
      },
      {
        path:"toastr",
        name:"toaster",
        component:toaster_advance,
        meta: {
          title: 'Bonus UI  Toaster',
        }
      },
      {
        path:"tour",
        name:"tour",
        component:tour_advance,
        meta: {
          title: 'Bonus UI  Tour',
        }
      },
      {
        path:"rating",
        name:"rating",
        component:rating_advance,
        meta: {
          title: 'Bonus UI  Rating',
        }
      },
      {
        path:"upload",
        name:"upload",
        component:upload_advance,
        meta: {
          title: 'Bonus UI  Upload',
        }
      },
      {
        path:"sticky",
        name:"sticky",
        component:sticky_advance,
        meta: {
          title: 'Bonus UI  Sticky',
        }
      },
      {
        path:"range-slider",
        name:"rangeslider",
        component:range_advance,
        meta: {
          title: 'Bonus UI  Range',
        }
      },
      {
        path:"dragdrop",
        name:"dragdrop",
        component:dragdrop,
        meta: {
          title: 'Bonus UI  Dragdrop',
        }
      }
    ]
  },
  {
    path:"/icons",
    component:BodyView,
    children:[
      {
        path:"flag",
        name:"flag",
        component:flag_Icon,
        meta: {
          title: 'Icons Flag',
        }
      },
      {
        path:"feather_icon",
        name:"feather",
        component:feather_icon,
        meta: {
          title: 'Icons Feather',
        }
      },
      {
        path:"whether",
        name:"weather",
        component:weather_icon,
        meta: {
          title: 'Icons Whether',
        }
      },
      {
        path:"themify",
        name:"themify",
        component:themify_icon,
        meta: {
          title: 'Icons Themify',
        }
      },
      {
        path:"fontawesome",
        name:"FontAwesome",
        component:font_Awesome,
        meta: {
          title: 'Icons Fontawesome',
        }
      },
      {
        path:"ico",
        name:"icon",
        component:icon_Icon,
        meta: {
          title: 'Icons Icoicon',
        }
      }
    ]
  },
  {
    path:"/buttons",
    component:BodyView,
    children:[
      {
        path:"default",
        name:"default",
        component:default_button,
        meta: {
          title: 'Default Button',
        }
      },
      {
        path:"flat",
        name:"flat",
        component:flat_button,
        meta: {
          title: 'Flat Button',
        }
      },
      {
        path:"edge",
        name:"edge",
        component:edge_button,
        meta: {
          title: 'Edge Button',
        }
      },
      {
        path:"raised",
        name:"raised",
        component:raised_button,
        meta: {
          title: 'Raised Button',
        }
      },
      {
        path:"group",
        name:"button_group",
        component:button_group,
        meta: {
          title: 'Group Button',
        }
      }
    ]
  },
  {
    path:"/chart",
    component:BodyView,
    children:[
      {
        path:"google",
        name:"googlechart",
        component:google_chart,
        meta: {
          title: 'Chart Google Chart| GetLokal Admin',
        }
      },
      {
        path:"apexChart",
        name:"apexchart",
        component:apex_chart,
        meta: {
          title: 'Chart Apex Chart| GetLokal Admin',
        }
      },
      {
        path:"chartist",
        name:"chartist",
        component:chartist_chart,
        meta: {
          title: 'Chart Chartist Chart| GetLokal Admin',
        }
      }
    ]
  },
  {
    path:"/gallery",
    component:BodyView,
    children:[
      {
        path:"grid-gallery",
        name:"gridgallery",
        component:grid_gallery,
        meta: {
          title: 'Grid Gallery',
        }
      },
      {
        path:"gallery-desc",
        name:"griddesc",
        component:grid_desc,
        meta: {
          title: 'Grid Gallery With Desc',
        }
      },
      {
        path:"hover-effect",
        name:"hovergallery",
        component:hover_gallery,
        meta: {
          title: 'Hover Gallery| GetLokal Admin',
        }
      },
      {
        path:"gallery-masonary",
        name:"masonry-gallery",
        component:masonry_gallery,
        meta: {
          title: 'Masonry',
        }
      },
      {
        path:"gallery-masonary-desc",
        name:"masonary-desc",
        component:masonary_desc,
        meta: {
          title: 'Masonry Desc| GetLokal Admin',
        }
      }

    ]
  },
 
  {
    path:"/auth",
    component: auth,
    children:[
      {
        path:"login",
        name:"login",
        component:login,
        meta: {
          title: 'GetLokal Admin',
        }
      }
    ]
  },
  {
    path:"/auth/company-register",
    name:"company-register",
    component: () => import("../pages/auth/CompanyRegister.vue"),
    meta: {
      title: 'Register Your Business | GetLokal Admin',
    }
  },
  {
    path:"/auth/owner-register",
    name:"owner-register",
    component: () => import("../pages/auth/OwnerRegister.vue"),
    meta: {
      title: 'Start Your Business | GetLokal Admin',
    }
  },
  {
    path:"/authentication/login/simple",
    name:"login-simple",
    component:login_simple,
    meta: {
      title: 'Login Simple| GetLokal Admin',
    }
  },
   {
     path:"/authentication/login/one",
     name:"login-image",
     component:login_image,
     meta: {
      title: 'Login Image| GetLokal Admin',
    }
   },
   {
     path:"/authentication/login/two",
     name:"login-image2",
     component:login_image2,
     meta: {
      title: 'Login Image Two| GetLokal Admin',
    }
   },
   {
    path:"/authentication/register/image",
    name:"ragister-image",
    component:ragister_image,
    meta: {
      title: 'Register Image| GetLokal Admin',
    }
   },
   {
     path:"/authentication/register/image2",
     name:"ragister-image2",
     component:ragister_image2,
     meta: {
      title: 'Register Image Two| GetLokal Admin',
    }
   },
  {
    path:"/auth/register",
    name:"ragister_simple",
    component:ragister_simple,
    meta: {
      title: 'Register| GetLokal Admin',
    }
  },
  {
    path:"/authentication/login/validate",
    name:"login-validation",
    component:login_with_validation,
    meta: {
      title: 'Login Validation| GetLokal Admin',
    }
  },
  {
    path:"/authentication/unlockuser",
    name:"unlock",
    component:unlock,
    meta: {
      title: 'Unlock User| GetLokal Admin',
    }
  },
  {
    path:"/authentication/forgetpassword",
    name:"forget-password",
    component:forget_password,
    meta: {
      title: 'Forget Password| GetLokal Admin',
    }
  },
  {
    path:"/authentication/resetpassword",
    name:"reset-password",
    component:reset_password,
    meta: {
      title: 'Reset Password| GetLokal Admin',
    }
  },
  {
    path:"/timeline",
    component:BodyView,
    children:[
      {
        path:"one",
        name:"timeline",
        component:timeline,
        meta: {
          title: 'Timeline',
        }
      }
    ]
  },
  {
    path:"/maps",
    component:BodyView,
    children:[
      {
        path:"vue-google-maps",
        name:"google-map",
        component:google_map,
        meta: {
          title: 'Google Map| GetLokal Admin',
        }
      },
      {
        path:"vue-leaflet-maps",
        name:"vueleaflet",
        component:vue_leaflet,
        meta: {
          title: 'Leaflet Map| GetLokal Admin',
        }
      }
    ]
  },
  {
    path:"/editor",
    component:BodyView,
    children:[
      {
        path:"ck-editor",
        name:"ckediter",
        component:ckediter,
        meta: {
          title: 'Ck Editor| GetLokal Admin',
        }
      },
      {
        path:"simple-editor",
        name:"simple-editer",
        component:simple_editer,
        meta: {
          title: 'Simple Editor| GetLokal Admin',
        }
      }
    ]
  },
  {
    path:"/blog",
    component:BodyView,
    children:[
      {
        path:"details",
        name:"blog-detail",
        component:blog_detail,
        meta: {
          title: 'Blog Details| GetLokal Admin',
        }
      },
      {
        path:"single",
        name:"blog_single",
        component:blog_single,
        meta: {
          title: 'Blog Single| GetLokal Admin',
        }
      }
    ]
  },
  {
    path:"/job",
    component:BodyView,
    children:[
      {
        path:"list",
        name:"listview",
        component:job_list,
        meta: {
          title: 'Job List| GetLokal Admin',
        }
      },
      {
        path:"/job/details/:id",
        name:"jobdetails",
        component:job_details,
        props:true,
        meta: {
          title: 'Job Details| GetLokal Admin',
        }
      },
      {
        path:"apply/:id",
        name:"jobapply",
        component:job_apply,
        meta: {
          title: 'Job Apply| GetLokal Admin',
        }
      }
    ]  
  },
  {
    path:"/learning",
    component:BodyView,
    children:[
      {
        path:"list",
        name:"learninglist",
        component:learning_list,
        meta: {
          title: 'Learning List| GetLokal Admin',
        }
      },
      {
        path:"details/:id",
        name:"coursedetailed",
        component:coursedetailed,
        meta: {
          title: 'course Detailed| GetLokal Admin',
        }
      }
    ]
  },
  // Owner Routes
  {
    path: '/owner',
    component: BodyView,
    children: [
      {
        path: 'dashboard',
        name: 'ownerDashboard',
        component: OwnerDashboard,
        meta: {
          title: 'Owner Dashboard | GetLokal Admin'
        }
      },
      {
        path: 'branches',
        name: 'ownerBranches',
        component: BranchList,
        meta: {
          title: 'My Branches | GetLokal Admin'
        }
      },
      {
        path: 'branches/create',
        name: 'ownerBranchCreate',
        component: BranchForm,
        meta: {
          title: 'Create Branch | GetLokal Admin'
        }
      },
      {
        path: 'branches/:id(\\d+)/edit',
        name: 'ownerBranchEdit',
        component: BranchForm,
        meta: {
          title: 'Edit Branch | GetLokal Admin'
        }
      },
      {
        path: 'tables',
        name: 'ownerTables',
        component: TableList,
        meta: {
          title: 'Table QR Codes | GetLokal Admin'
        }
      },
      {
        path: 'branches/:branchId(\\d+)/tables',
        name: 'ownerBranchTables',
        component: TableList,
        meta: {
          title: 'Table QR Codes | GetLokal Admin'
        }
      },
      {
        path: 'branches/:branchId(\\d+)/staff',
        name: 'ownerBranchStaff',
        component: StaffList,
        meta: {
          title: 'Branch Staff | GetLokal Admin'
        }
      },
      {
        path: 'staff',
        name: 'ownerStaff',
        component: StaffList,
        meta: {
          title: 'Staff Management | GetLokal Admin'
        }
      },
      {
        path: 'staff/create',
        name: 'ownerStaffCreate',
        component: StaffForm,
        meta: {
          title: 'Add Staff | GetLokal Admin'
        }
      },
      {
        path: 'staff/:id(\\d+)/edit',
        name: 'ownerStaffEdit',
        component: StaffForm,
        meta: {
          title: 'Edit Staff | GetLokal Admin'
        }
      },
      // Categories
      {
        path: 'categories',
        name: 'ownerCategories',
        component: CategoryList,
        meta: {
          title: 'Categories | GetLokal Admin'
        }
      },
      {
        path: 'categories/create',
        name: 'ownerCategoryCreate',
        component: CategoryForm,
        meta: {
          title: 'Create Category | GetLokal Admin'
        }
      },
      {
        path: 'categories/:id(\\d+)/edit',
        name: 'ownerCategoryEdit',
        component: CategoryForm,
        meta: {
          title: 'Edit Category | GetLokal Admin'
        }
      },
      // Products
      {
        path: 'products',
        name: 'ownerProducts',
        component: ProductList,
        meta: {
          title: 'Products | GetLokal Admin'
        }
      },
      {
        path: 'products/create',
        name: 'ownerProductCreate',
        component: ProductForm,
        meta: {
          title: 'Create Product | GetLokal Admin'
        }
      },
      {
        path: 'products/:id(\\d+)/edit',
        name: 'ownerProductEdit',
        component: ProductForm,
        meta: {
          title: 'Edit Product | GetLokal Admin'
        }
      },
      // Add-ons (reusable across products)
      {
        path: 'addons',
        name: 'ownerAddons',
        component: AddonList,
        meta: {
          title: 'Add-ons | GetLokal Admin'
        }
      },
      {
        path: 'addons/create',
        name: 'ownerAddonCreate',
        component: AddonForm,
        meta: {
          title: 'Create Add-on | GetLokal Admin'
        }
      },
      {
        path: 'addons/:id(\\d+)/edit',
        name: 'ownerAddonEdit',
        component: AddonForm,
        meta: {
          title: 'Edit Add-on | GetLokal Admin'
        }
      },
      // Stock Management
      {
        path: 'stock',
        name: 'ownerStock',
        component: StockList,
        meta: {
          title: 'Stock Levels | GetLokal Admin'
        }
      },
      {
        path: 'branches/:branchId(\\d+)/stock',
        name: 'ownerBranchStock',
        component: StockList,
        meta: {
          title: 'Branch Stock | GetLokal Admin'
        }
      },
      {
        path: 'branches/:branchId(\\d+)/stock/movements',
        name: 'ownerStockMovements',
        component: StockMovementHistory,
        meta: {
          title: 'Stock Movement History | GetLokal Admin'
        }
      },
      // Stock Transfers
      {
        path: 'transfers',
        name: 'ownerTransfers',
        component: TransferList,
        meta: {
          title: 'Stock Transfers | GetLokal Admin'
        }
      },
      {
        path: 'transfers/create',
        name: 'ownerTransferCreate',
        component: TransferForm,
        meta: {
          title: 'Create Transfer | GetLokal Admin'
        }
      },
      {
        path: 'transfers/:id(\\d+)',
        name: 'ownerTransferDetail',
        component: TransferDetail,
        meta: {
          title: 'Transfer Details | GetLokal Admin'
        }
      },
      // Customer Management
      {
        path: 'customers',
        name: 'ownerCustomers',
        component: CustomerList,
        meta: {
          title: 'Customers | GetLokal Admin'
        }
      },
      {
        path: 'customers/:id(\\d+)',
        name: 'ownerCustomerDetail',
        component: CustomerDetail,
        meta: {
          title: 'Customer Details | GetLokal Admin'
        }
      },
      // Online Orders Management
      {
        path: 'orders',
        name: 'ownerOrders',
        component: OrderList,
        meta: {
          title: 'Online Orders | GetLokal Admin'
        }
      },
      {
        path: 'orders/:id(\\d+)',
        name: 'ownerOrderDetail',
        component: OrderDetail,
        meta: {
          title: 'Order Details | GetLokal Admin'
        }
      },
      // Subscription Management
      {
        path: 'subscription',
        name: 'ownerSubscription',
        component: SubscriptionPlans,
        meta: {
          title: 'Subscription Plans | GetLokal Admin'
        }
      },
      {
        path: 'billing',
        name: 'ownerBilling',
        component: BillingHistory,
        meta: {
          title: 'Billing History | GetLokal Admin'
        }
      },
      // Reviews
      {
        path: 'reviews',
        name: 'ownerReviews',
        component: OwnerReviews,
        meta: {
          title: 'Reviews | GetLokal Admin'
        }
      },
      // Notifications
      {
        path: 'notifications',
        name: 'ownerNotifications',
        component: OwnerNotifications,
        meta: {
          title: 'Notifications | GetLokal Admin'
        }
      },
      // Loyalty Programme (read-only guide)
      {
        path: 'loyalty',
        name: 'ownerLoyalty',
        component: OwnerLoyaltyGuide,
        meta: {
          title: 'Loyalty Programme | GetLokal Admin'
        }
      },
      // Reports & Analytics
      {
        path: 'reports',
        name: 'ownerReports',
        component: OwnerReports,
        meta: {
          title: 'Reports & Analytics | GetLokal Admin'
        }
      },
      // System Settings
      {
        path: 'settings',
        name: 'ownerSettings',
        component: OwnerSettings,
        meta: {
          title: 'Settings | GetLokal Admin'
        }
      },
      // Loyverse POS Integration
      {
        path: 'loyverse',
        name: 'ownerLoyverseOrders',
        component: LoyverseOrders,
        meta: {
          title: 'POS Orders | GetLokal Admin'
        }
      },
      {
        path: 'loyverse/settings',
        name: 'ownerLoyverseSettings',
        component: LoyverseSettings,
        meta: {
          title: 'Loyverse Settings | GetLokal Admin'
        }
      }
    ]
  },
  // Super Admin Routes
  {
    path: '/super-admin',
    component: BodyView,
    meta: { requiresSuperAdmin: true },
    children: [
      {
        path: 'dashboard',
        name: 'superAdminDashboard',
        component: PlatformDashboard,
        meta: {
          title: 'Platform Dashboard | GetLokal Admin',
          requiresSuperAdmin: true
        }
      },
      {
        path: 'companies',
        name: 'superAdminCompanies',
        component: SACompanyList,
        meta: {
          title: 'All Companies | GetLokal Admin',
          requiresSuperAdmin: true
        }
      },
      {
        path: 'companies/:id(\\d+)',
        name: 'superAdminCompanyDetail',
        component: SACompanyDetail,
        meta: {
          title: 'Company Details | GetLokal Admin',
          requiresSuperAdmin: true
        }
      },
      {
        path: 'customers',
        name: 'superAdminCustomers',
        component: SACustomerList,
        meta: {
          title: 'All Customers | GetLokal Admin',
          requiresSuperAdmin: true
        }
      },
      {
        path: 'customers/:id(\\d+)',
        name: 'superAdminCustomerDetail',
        component: SACustomerDetail,
        meta: {
          title: 'Customer Details | GetLokal Admin',
          requiresSuperAdmin: true
        }
      },
      {
        path: 'subscriptions',
        name: 'superAdminSubscriptions',
        component: SASubscriptionList,
        meta: {
          title: 'All Subscriptions | GetLokal Admin',
          requiresSuperAdmin: true
        }
      },
      {
        path: 'plans',
        name: 'superAdminPlans',
        component: SAPlanManager,
        meta: {
          title: 'Manage Plans | GetLokal Admin',
          requiresSuperAdmin: true
        }
      },
      {
        path: 'invoices',
        name: 'superAdminInvoices',
        component: SAInvoiceList,
        meta: {
          title: 'All Invoices | GetLokal Admin',
          requiresSuperAdmin: true
        }
      },
      {
        path: 'wallets',
        name: 'superAdminWallets',
        component: SAWalletDashboard,
        meta: {
          title: 'Wallet Management | GetLokal Admin',
          requiresSuperAdmin: true
        }
      },
      {
        path: 'promos',
        name: 'superAdminPromos',
        component: SAPromoList,
        meta: {
          title: 'Promo Codes | GetLokal Admin',
          requiresSuperAdmin: true
        }
      },
      {
        path: 'promos/create',
        name: 'superAdminPromoCreate',
        component: SAPromoForm,
        meta: {
          title: 'Create Promo Code | GetLokal Admin',
          requiresSuperAdmin: true
        }
      },
      {
        path: 'promos/:id(\\d+)/edit',
        name: 'superAdminPromoEdit',
        component: SAPromoForm,
        meta: {
          title: 'Edit Promo Code | GetLokal Admin',
          requiresSuperAdmin: true
        }
      },
      // Loyalty Management
      {
        path: 'loyalty/tiers',
        name: 'superAdminLoyaltyTiers',
        component: SATierList,
        meta: {
          title: 'Membership Tiers | GetLokal Admin',
          requiresSuperAdmin: true
        }
      },
      {
        path: 'loyalty/tiers/create',
        name: 'superAdminLoyaltyTierCreate',
        component: SATierForm,
        meta: {
          title: 'Add Tier | GetLokal Admin',
          requiresSuperAdmin: true
        }
      },
      {
        path: 'loyalty/tiers/:id(\\d+)/edit',
        name: 'superAdminLoyaltyTierEdit',
        component: SATierForm,
        meta: {
          title: 'Edit Tier | GetLokal Admin',
          requiresSuperAdmin: true
        }
      },
      {
        path: 'loyalty/settings',
        name: 'superAdminLoyaltySettings',
        component: SALoyaltySettings,
        meta: {
          title: 'Loyalty Settings | GetLokal Admin',
          requiresSuperAdmin: true
        }
      },
      // Delivery Management
      {
        path: 'delivery',
        name: 'superAdminDeliveryDashboard',
        component: SADeliveryDashboard,
        meta: {
          title: 'Delivery Dashboard | GetLokal Admin',
          requiresSuperAdmin: true
        }
      },
      {
        path: 'delivery/list',
        name: 'superAdminDeliveryList',
        component: SADeliveryList,
        meta: {
          title: 'All Deliveries | GetLokal Admin',
          requiresSuperAdmin: true
        }
      },
      {
        path: 'delivery/settings',
        name: 'superAdminDeliverySettings',
        component: SADeliverySettings,
        meta: {
          title: 'Delivery Settings | GetLokal Admin',
          requiresSuperAdmin: true
        }
      },
      {
        path: 'delivery/riders',
        name: 'superAdminRiders',
        component: SARiderList,
        meta: {
          title: 'Riders | GetLokal Admin',
          requiresSuperAdmin: true
        }
      }
    ]
  }

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkExactActiveClass: 'active',
})

router.beforeEach((to, from, next) => {
  // Set page title
  if (typeof (to.meta.title) === 'string') {
    document.title = to.meta.title;
  }

  // Public routes that don't require authentication
  const publicPaths = ['/auth/login', '/auth/register', '/auth/owner-register', '/auth/company-register', '/authentication/forgetpassword', '/authentication/resetpassword'];
  const isPublicPath = publicPaths.includes(to.path);

  // Check if user is authenticated
  const token = localStorage.getItem('getlokal_admin_token');
  const userStr = localStorage.getItem('getlokal_admin_user');
  const isAuthenticated = !!token;
  const user = userStr ? JSON.parse(userStr) : null;
  const isSuperAdmin = user?.is_super_admin === true;

  if (isPublicPath) {
    // If already logged in and trying to access login page, redirect based on role
    if (isAuthenticated && to.path === '/auth/login') {
      if (isSuperAdmin) {
        return next('/super-admin/dashboard');
      }
      return next('/owner/dashboard');
    }
    return next();
  }

  // Protected route - require authentication
  if (!isAuthenticated) {
    return next('/auth/login');
  }

  // Role-based route protection
  const requiresSuperAdmin = to.matched.some(record => record.meta.requiresSuperAdmin);
  const isOwnerRoute = to.path.startsWith('/owner');
  const isSuperAdminRoute = to.path.startsWith('/super-admin');

  // Super admin trying to access owner routes - redirect to super admin dashboard
  if (isSuperAdmin && isOwnerRoute) {
    return next('/super-admin/dashboard');
  }

  // Non-super admin trying to access super admin routes - redirect to owner dashboard
  if (!isSuperAdmin && isSuperAdminRoute) {
    return next('/owner/dashboard');
  }

  // Handle default route redirect based on role
  if (to.path === '/' || to.path === '/dashboard/default') {
    if (isSuperAdmin) {
      return next('/super-admin/dashboard');
    }
    return next('/owner/dashboard');
  }

  next();
});

router.afterEach((to) => {
  const title = to.meta?.title || 'GetLokal Admin';
  document.title = title;
});

export default router
